import { render } from "./EditIncomePage.vue?vue&type=template&id=4bd15e8c&ts=true"
import script from "./EditIncomePage.vue?vue&type=script&lang=ts"
export * from "./EditIncomePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__